import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentsService } from 'src/app/services/document.service';
import { environment } from 'src/environments/environment';
import { QuillModule } from 'ngx-quill';
import { Router, RouterModule } from '@angular/router';
import Swal from "sweetalert2";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
declare var $: any;

@Component({
  selector: 'app-calendario',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    QuillModule,
    RouterModule
  ],
  templateUrl: './calendario.component.html',
  styleUrl: './calendario.component.css'
})
export class CalendarioComponent implements OnInit, OnChanges {
  @Output() programaActualizado = new EventEmitter<void>(); // Emitirá un evento cuando se actualice
  @Output() programaClienteActualizado = new EventEmitter<void>(); // Emitirá un evento cuando se actualice
  @Input({required: true}) userInfo: any;
  @Input({required: true}) detallePrograma: any;
  @Input({required: true}) idPeriodo: any;
  @Input({required: true}) detalleCliente: any;
  detallePeriodo: any;
  patternRutinas = 'rutina'
  patternDietas = 'dieta'
  semanas: any[] = [];
  listaRutinas: any = [];
  listaDietas: any = [];

  sectionActive: "info" | "rutinas" | "avisos" | "dietas" = 'info';
  infoPeriodo: any;
  contenidoSanitizado: SafeHtml;
  rutinasPeriodo: any = [];
  dietasPeriodo: any = [];
  selectedDays: any[] = [];  // Arreglo para almacenar los días seleccionados

  constructor(
    private documentService: DocumentsService,
    private sanitizer: DomSanitizer,
    private router: Router) {
    // this.generateCalendar();
    if (this.detalleCliente ) {
      if(this.detallePrograma.tipo == '2') this.generarCalendarioClientePrediseñado();
      if(this.detallePrograma.tipo == '1') this.generarCalendarioClientePersonalizado();
    } else this.generateCalendar();
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log('Cambios detectados:', changes);
    console.log('detallePrograma', this.detallePrograma)
    console.log('detalleCliente', this.detalleCliente)
    console.log('idPeriodo', this.idPeriodo)
    this.detallePeriodo = this.detallePrograma?.periodos[this.idPeriodo];

    // Obtener la información del periodo
    if(this.detallePrograma.tipo == '1' && this.detalleCliente) {
      this.infoPeriodo = this.detalleCliente.expediente.programas.find(r => r.configuracionPrograma.id === this.detallePrograma.documentId).periodos[this.idPeriodo].informacion ? 
      this.detalleCliente.expediente.programas.find(r => r.configuracionPrograma.id === this.detallePrograma.documentId).periodos[this.idPeriodo].informacion
      : '';
    } else this.infoPeriodo = this.detallePeriodo?.informacion ? this.detallePeriodo.informacion : '';
    if(this.detalleCliente && this.detallePrograma.tipo == '2') this.sanitizarContenido();

    // Obtener las rutinas del periodo
    debugger
    this.rutinasPeriodo = [];
    if(this.listaRutinas.length > 0) {
      if(!this.detalleCliente && this.detallePrograma.tipo=='2' && this.detallePeriodo?.rutinas) {
        for(let rutina of this.detallePeriodo?.rutinas) {
          this.rutinasPeriodo.push(rutina);
          //this.rutinasPeriodo.push(this.listaRutinas.find(r => r.documentId === rutina.documentId));
        }
      } else if(this.detalleCliente && this.detallePrograma.tipo == '1') {
        if(this.detalleCliente.expediente.programas.find(r => r.configuracionPrograma.id === this.detallePrograma.documentId).periodos[this.idPeriodo].rutinas) {
          for(let rutina of this.detalleCliente.expediente.programas.find(r => r.configuracionPrograma.id === this.detallePrograma.documentId).periodos[this.idPeriodo].rutinas) {
            this.rutinasPeriodo.push(rutina);
            //this.rutinasPeriodo.push(this.listaRutinas.find(r => r.documentId === rutina.documentId));
          }
        }
      }
    }

    // Obtener las dietas del periodo
    this.dietasPeriodo = [];
    if(this.listaDietas.length > 0) {
      if(!this.detalleCliente && this.detallePrograma.tipo=='2' && this.detallePeriodo?.dietas) {
        for(let dieta of this.detallePeriodo?.dietas) {
          this.dietasPeriodo.push(dieta);
        }
      } else if(this.detalleCliente && this.detallePrograma.tipo == '1') {
        if(this.detalleCliente.expediente.programas.find(r => r.configuracionPrograma.id === this.detallePrograma.documentId).periodos[this.idPeriodo].dietas) {
          for(let dieta of this.detalleCliente.expediente.programas.find(r => r.configuracionPrograma.id === this.detallePrograma.documentId).periodos[this.idPeriodo].dietas) {
            this.dietasPeriodo.push(dieta);
          }
        }
      }
    }

    if (changes['detallePrograma']) {
      if (this.detalleCliente) {
        if(this.detallePrograma.tipo == '2') this.generarCalendarioClientePrediseñado();
        if(this.detallePrograma.tipo == '1') this.generarCalendarioClientePersonalizado();
      } else this.generateCalendar();
    }
    if(sessionStorage.getItem('subseccion')) {
      this.sectionActive = sessionStorage.getItem('subseccion') as 'info' | 'rutinas' | 'avisos';
      sessionStorage.removeItem('subseccion');
    }
    console.log('detalleCliente', this.detalleCliente)
  }
  ngOnInit(): void {
    this.getRutinas();
    this.getDietas()
  }
  navigateToRutinas() {
    const periodoId = String(this.idPeriodo + 1);
    if(this.detalleCliente && this.detallePrograma.tipo == '1') {
      this.router.navigate(['trainer/rutinas', this.detalleCliente.documentId, this.detallePrograma.documentId, periodoId])
    }
    if(this.detallePrograma.tipo == '2') {
      this.router.navigate(['trainer/rutinas', this.detallePrograma.documentId, periodoId])
    }
  }
  navigateToDietas() {
    const periodoId = String(this.idPeriodo + 1);
    if(this.detalleCliente && this.detallePrograma.tipo == '1') {
      this.router.navigate(['trainer/dietas', this.detalleCliente.documentId, this.detallePrograma.documentId, periodoId])
    }
    if(this.detallePrograma.tipo == '2') {
      this.router.navigate(['trainer/dietas', this.detallePrograma.documentId, periodoId])
    }
  }
  sanitizarContenido(): void {
    this.contenidoSanitizado = this.sanitizer.bypassSecurityTrustHtml(this.infoPeriodo);
  }

  onEditorCreated(quill: any): void {
    quill.getModule('toolbar').addHandler('image', () => {
      // Bloquear el botón de imagen
      alert('La funcionalidad de imágenes está deshabilitada.');
    });
  
    quill.clipboard.addMatcher('IMG', (node: any, delta: any) => {
      // Bloquear imágenes pegadas
      return null;
    });
  }

  guardarCambios(opcion: 'informacion' | 'rutinas' | 'rutinasPorDia' | 'avisos') {
    if(!this.detalleCliente && this.detallePrograma.tipo == '2') {
      this.updateProgramaDocument(opcion);
    } else if(this.detalleCliente && this.detallePrograma.tipo == '1') {
      this.updateClienteDocument(opcion);
    }
  }

  updateClienteDocument(opcion: 'informacion' | 'rutinas' | 'rutinasPorDia' | 'avisos')
  {
    console.log('========================== '+opcion+' =================================')
    const index = this.detalleCliente.expediente.programas.findIndex((item) => item.configuracionPrograma.id === this.detallePrograma?.documentId);
    let programas = [...this.detalleCliente.expediente.programas];

    if(opcion === 'informacion') {
      programas[index].periodos[this.idPeriodo].informacion = this.infoPeriodo;
    }
    if(opcion === 'rutinas') {
      programas[index].periodos[this.idPeriodo].rutinas = [];
      for(let rutina of this.rutinasPeriodo) {
        programas[index].periodos[this.idPeriodo].rutinas.push({ nombre: rutina.nombre, documentId: rutina.documentId });
      }
    }
    if(opcion === 'rutinasPorDia') {
      let periodos = [...programas[index].periodos];
      let rutinasPorDia = [];
      let periodo = 1;
      for(let semana of this.semanas) {
        for(let dia of semana) {
          if(periodo != dia.periodo) {
            periodos[periodo-1].rutinasPorDia = [...rutinasPorDia];
            rutinasPorDia = [];
            periodo++;
          }
          rutinasPorDia.push({
            fechaDate:  new Date(dia.fechaDate).toISOString(), // Convertir a string en formato ISO
            fecha: dia.fecha, // Formatear la fecha
            periodo: dia.periodo,
            rutina: dia.rutina,
            dieta: dia.dieta
          });
        }
      }
      periodos[periodo-1].rutinasPorDia = [...rutinasPorDia];
    }
    
    let expedienteClienteDocument: any = {
      expediente: { 
        programas: programas
      }
    }
    // console.log('--> expedienteClienteDocument', expedienteClienteDocument)
    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,
      this.detalleCliente.documentId,
      "cliente",
      null,
      expedienteClienteDocument
    ).subscribe({
      next: (data: any) => {
        console.log(data);
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        if(opcion == 'rutinas') this.rutinasPeriodo = this.detallePeriodo?.rutinas ? [...this.detallePeriodo.rutinas] : [];
        // Swal.fire({
        //   toast: true, // Activa el estilo tipo Toast
        //   position: 'bottom-end', // Posición del mensaje
        //   icon: 'success',
        //   title: 'Periodo actualizado con éxito.',
        //   showConfirmButton: false,
        //   timer: 5000, // Tiempo de duración del mensaje (5 segundos)
        //   timerProgressBar: true // Muestra una barra de progreso
        // });
        // Emitir el evento hacia el padre
        this.programaClienteActualizado.emit();
      }
    })
  }

  updateProgramaDocument(opcion: 'informacion' | 'rutinas' | 'rutinasPorDia' | 'avisos')
  {
    debugger
    console.log('detallePrograma', this.detallePrograma)

    let periodos = [...this.detallePrograma.periodos];
    let programaDocument: any = {};
    if(opcion === 'informacion') {
      periodos[this.idPeriodo].informacion = this.infoPeriodo;
    }
    if(opcion === 'rutinas') {
      periodos[this.idPeriodo].rutinas = [];
      for(let rutina of this.rutinasPeriodo) {
        periodos[this.idPeriodo].rutinas.push({ nombre: rutina.nombre, documentId: rutina.documentId });
      }
    }
    if(opcion === 'rutinasPorDia') {
      let periodos = [...this.detallePrograma.periodos];
      let rutinasPorDia = [];
      let periodo = 1;
      for(let semana of this.semanas) {
        for(let dia of semana) {
          if(periodo != dia.periodo) {
            periodos[periodo-1].rutinasPorDia = [...rutinasPorDia];
            rutinasPorDia = [];
            periodo++;
          }
          rutinasPorDia.push(dia);
        }
      }
      periodos[periodo-1].rutinasPorDia = [...rutinasPorDia];
    }

    programaDocument = {
      periodos: periodos
    }
    console.log('--> programaDocument',programaDocument)
    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,
      this.detallePrograma.documentId,
      "programa",
      null,
      programaDocument
    ).subscribe({
      next: (data: any) => {
        console.log(data);
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        if(opcion == 'rutinas') this.rutinasPeriodo = this.detallePeriodo?.rutinas ? [...this.detallePeriodo.rutinas] : [];
        // Swal.fire({
        //   toast: true, // Activa el estilo tipo Toast
        //   position: 'bottom-end', // Posición del mensaje
        //   icon: 'success',
        //   title: 'Periodo actualizado con éxito.',
        //   showConfirmButton: false,
        //   timer: 5000, // Tiempo de duración del mensaje (5 segundos)
        //   timerProgressBar: true // Muestra una barra de progreso
        // });

        // Emitir el evento hacia el padre
        this.programaActualizado.emit();
      }
    })
  }

  getRutinas(){
    const filters: any = {
      "documentContainerId": this.userInfo.documentContainerId,
      "empresaId": this.userInfo.empresaId,
      "activo": true
    };
    // GET FILTERS ARRAY
    let filtersQuery: any = this.documentService.getFiltersArray(filters);
    const query = {
      "sort": [
        {
          "esDocumentDate": {
            "order": "desc",
            "unmapped_type": "boolean"
          }
        }
      ],
      "size": 200,
      "query": {
        "bool": {
          "must": [],
          "filter": filtersQuery,
          "should": [],
          "must_not": []
        }
      }
    };
    setTimeout(() => {
      this.documentService.searchDocument(environment.businessId, this.patternRutinas, query).subscribe({
        next: (data: any) => {
          console.log(data)
          this.listaRutinas = [];
          this.listaRutinas = data;
          
          this.rutinasPeriodo = [];
          if(this.detalleCliente && this.detallePrograma.tipo == '1') {
            if(this.detalleCliente.expediente.programas.find(r => r.configuracionPrograma.id === this.detallePrograma.documentId).periodos[this.idPeriodo].rutinas) {
              for(let rutina of this.detalleCliente.expediente.programas.find(r => r.configuracionPrograma.id === this.detallePrograma.documentId).periodos[this.idPeriodo].rutinas) {
                this.rutinasPeriodo.push(rutina);
                //this.rutinasPeriodo.push(this.listaRutinas.find(r => r.documentId === rutina.documentId));
              }
            }
          } else {
            for(let rutina of this.detallePeriodo?.rutinas) {
              //this.rutinasPeriodo.push(this.listaRutinas.find(r => r.documentId === rutina.documentId));
              this.rutinasPeriodo.push(rutina);
            }
          }
          this.rutinasPeriodo.sort((a, b) => a.nombre.localeCompare(b.nombre));
          // console.log('rutinasPeriodo', this.rutinasPeriodo)
        },
          error: (error: any) => {
          console.error(error);
          this.listaRutinas = [];
        }
      });
    }, 1500);
  }

  // getDietas(){
  //   const filters: any = {
  //     "documentContainerId": this.userInfo.documentContainerId,
  //     "empresaId": this.userInfo.empresaId,
  //     "activo": true
  //   };
  //   // GET FILTERS ARRAY
  //   let filtersQuery: any = this.documentService.getFiltersArray(filters);
  //   const query = {
  //     "sort": [
  //       {
  //         "esDocumentDate": {
  //           "order": "desc",
  //           "unmapped_type": "boolean"
  //         }
  //       }
  //     ],
  //     "size": 200,
  //     "query": {
  //       "bool": {
  //         "must": [],
  //         "filter": filtersQuery,
  //         "should": [],
  //         "must_not": []
  //       }
  //     }
  //   };
  //   setTimeout(() => {
  //     this.documentService.searchDocument(environment.businessId, this.patternDietas, query).subscribe({
  //       next: (data: any) => {
  //         console.log(data)
  //         this.listaDietas = [];
  //         this.listaDietas = data;
  //
  //         this.dietasPeriodo = [];
  //         if(this.detalleCliente && this.detallePrograma.tipo == '1') {
  //           if(this.detalleCliente.expediente.programas.find(r => r.configuracionPrograma.id === this.detallePrograma.documentId).periodos[this.idPeriodo].dietas) {
  //             for(let dieta of this.detalleCliente.expediente.programas.find(r => r.configuracionPrograma.id === this.detallePrograma.documentId).periodos[this.idPeriodo].dietas) {
  //               this.dietasPeriodo.push(dieta);
  //             }
  //           }
  //         } else {
  //           for(let dieta of this.detallePeriodo?.dietas) {
  //             this.dietasPeriodo.push(dieta);
  //           }
  //         }
  //         this.dietasPeriodo.sort((a, b) => a.nombre.localeCompare(b.nombre));
  //         // console.log('rutinasPeriodo', this.rutinasPeriodo)
  //       },
  //       error: (error: any) => {
  //         console.error(error);
  //         this.listaRutinas = [];
  //       }
  //     });
  //   }, 1500);
  // }

  getDietas(){
    this.documentService.getDocumentsByType(environment.businessId, this.userInfo.documentContainerId, 'dieta').subscribe((data: any) => {
      console.log(data)
      this.listaDietas = [];
      this.listaDietas = data.content;

      this.dietasPeriodo = [];
      if(this.detalleCliente && this.detallePrograma.tipo == '1') {
        if(this.detalleCliente.expediente.programas.find(r => r.configuracionPrograma.id === this.detallePrograma.documentId).periodos[this.idPeriodo].dietas) {
          for(let dieta of this.detalleCliente.expediente.programas.find(r => r.configuracionPrograma.id === this.detallePrograma.documentId).periodos[this.idPeriodo].dietas) {
            this.dietasPeriodo.push(dieta);
          }
        }
      } else {
        for(let dieta of this.detallePeriodo?.dietas) {
          this.dietasPeriodo.push(dieta);
        }
      }
      this.dietasPeriodo.sort((a, b) => a.nombre.localeCompare(b.nombre));
    }, err => {
      console.error(err)
    })
  }

  changeSectionActive(section: 'info' | 'rutinas' | 'avisos' | 'dietas')
  {
    this.sectionActive = section;
  }

  generateCalendar() {
    debugger
    this.semanas = [];
    let currentDay = 1;
    let currentPeriod = 1; // Identificador de periodo
    for (let per = 0; per < this.detallePrograma?.cantPeriodos; per++) {
      for (let sem = 0; sem < this.detallePrograma?.cantSemanas; sem++) {
        const week = [];
        for (let j = 0; j < 7; j++) {
          const index = this.detallePrograma.periodos[currentPeriod-1].rutinasPorDia?.findIndex(r => r.dia === currentDay);
          week.push({ 
            dia: currentDay++, 
            rutina: index != undefined ? this.detallePrograma.periodos[currentPeriod-1].rutinasPorDia[index].rutina : {}, // Rutina vacía inicial
            dieta: index != undefined ? this.detallePrograma.periodos[currentPeriod-1].rutinasPorDia[index].dieta : {}, // Dieta vacía inicial
            periodo: currentPeriod // Asignar el periodo actual
          });
        }
        this.semanas.push(week);
      }
      currentPeriod++; // Cambiar al siguiente periodo
    }
    console.log('semanas', this.semanas)
  }

  generarCalendarioClientePrediseñado(): void {
    debugger
    this.semanas = [];
    const index = this.detalleCliente.expediente.programas.findIndex(r => r.configuracionPrograma.id === this.detallePrograma.documentId);
    let rutinasPeriodos = []; // Todas las rutinas de todos los periodos
    for(let rutinasPeriodo of this.detallePrograma.periodos) {
      for(let rutina of rutinasPeriodo.rutinasPorDia) {
        rutinasPeriodos.push(rutina);
      }
    }
    // console.log('rutinasPeriodos', rutinasPeriodos)
    let indexDia = 0;
    for (let periodo of this.detalleCliente.expediente.programas[index].periodos) {
      const fechaInicio = new Date(periodo.fechaInicioDate);
      const fechaFin = new Date(periodo.fechaFinDate);
      let semana = [];
      let diaActual = new Date(fechaInicio);

      while (diaActual <= fechaFin) {

        semana.push({
          fechaDate: new Date(diaActual),
          fecha: this.formatearFecha(new Date(diaActual)), // Formatear la fecha
          periodo: periodo.periodo,
          rutina: { nombre: rutinasPeriodos[indexDia].rutina.nombre },
          dieta: { nombre: rutinasPeriodos[indexDia].dieta ? rutinasPeriodos[indexDia].dieta.nombre : '' }
        });

        if (diaActual.getDay() === 0) { // Domingo
          this.semanas.push(semana);
          semana = [];
        }
        indexDia++;
        diaActual.setDate(diaActual.getDate() + 1);
      }

      if (semana.length > 0) {
        this.semanas.push(semana);
      }
    }
    // console.log('semanas', this.semanas);
  }
  generarCalendarioClientePersonalizado(): void {
    this.semanas = [];
    const index = this.detalleCliente.expediente.programas.findIndex(r => r.configuracionPrograma.id === this.detallePrograma.documentId);

    let rutinasPeriodos = []; // Todas las rutinas de todos los periodos
    for(let periodo of  this.detalleCliente.expediente.programas[index].periodos) {
      if(periodo.rutinasPorDia) {
        for(let rutina of periodo.rutinasPorDia) {
          rutinasPeriodos.push(rutina);
        }
      }
    }
    // console.log('rutinasPeriodos', rutinasPeriodos)
    let indexDia = 0;
    for (let periodo of this.detalleCliente.expediente.programas[index].periodos) {
      const fechaInicio = new Date(periodo.fechaInicioDate);
      const fechaFin = new Date(periodo.fechaFinDate);
      let semana = [];
      let diaActual = new Date(fechaInicio);

      while (diaActual <= fechaFin) {
        semana.push({
          fechaDate:  new Date(diaActual),
          fecha: this.formatearFecha(new Date(diaActual)), // Formatear la fecha
          periodo: periodo.periodo,
          rutina: rutinasPeriodos.length > 0 ? rutinasPeriodos[indexDia].rutina : {},
          dieta: rutinasPeriodos.length > 0 ? rutinasPeriodos[indexDia].dieta : {}
        });

        if (diaActual.getDay() === 0) { // Domingo
          this.semanas.push(semana);
          semana = [];
        }
        indexDia++;
        diaActual.setDate(diaActual.getDate() + 1);
      }

      if (semana.length > 0) {
        this.semanas.push(semana);
      }
    }
    console.log('semanas', this.semanas);
  }
  // Método para formatear la fecha en dd-mm-aaaa
  formatearFecha(fecha: Date): string {
    const dia = fecha.getDate().toString().padStart(2, '0');
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const anio = fecha.getFullYear();
    return `${dia}-${mes}-${anio}`;
  }
  
  getColorByPeriod(periodo: number): string {
    const colors = ['#ffcccc80', '#cce5ff7b', '#d4edda79', '#fff3cd79', '#f8d7da7d']
    return colors[periodo % colors.length]; // Rotar colores si hay más periodos que colores
  }

  // Selecciona o deselecciona un día
  seleccionarDia(day: any) {
    const index = this.selectedDays.indexOf(day);
    if (index > -1) {
      // Si el día ya está seleccionado, se deselecciona
      this.selectedDays.splice(index, 1);
    } else {
      // Si no está seleccionado, se añade a la lista
      this.selectedDays.push(day);
    }
    console.log('Días seleccionados:', this.selectedDays);
  }

  // Asigna una rutina a todos los días seleccionados
  agregarRutinaADias(rutina: any | 'libre', day: any) {
    debugger
    if(day) { // Si se seleccionó un día específico es porque se eliminará rutina de ese día
      let index = this.selectedDays.indexOf(day);
      if (index == -1) this.seleccionarDia(day);
      index = this.selectedDays.indexOf(day);
      this.selectedDays[index].rutina = {}
      this.selectedDays.splice(index, 1);
    } else { // Si no se seleccionó un día específico, se asignará la rutina a todos los días seleccionados
      this.selectedDays.forEach(day => {
        if (rutina === 'libre') {
          day.rutina = { nombre: 'Día libre' };
        } else {
          day.rutina = rutina.nombre ? { nombre: rutina.nombre, documentId: rutina.documentId } : {}; // Asigna la rutina
        }
      });
      this.selectedDays = [];
    }
    // Limpia la selección después de asignar la rutina
    console.log('Rutinas asignadas. Semanas actualizadas:', this.semanas);
    this.guardarCambios('rutinasPorDia')
  }

  // Asigna una dieta a todos los días seleccionados
  agregarDietaADias(dieta: any | 'libre', day: any) {
    debugger
    if(day) { // Si se seleccionó un día específico es porque se eliminará dieta de ese día
      let index = this.selectedDays.indexOf(day);
      if (index == -1) this.seleccionarDia(day);
      index = this.selectedDays.indexOf(day);
      this.selectedDays[index].dieta = {}
      this.selectedDays.splice(index, 1);
    } else { // Si no se seleccionó un día específico, se asignará la dieta a todos los días seleccionados
      this.selectedDays.forEach(day => {
        if (dieta === 'libre') {
          day.dieta = { nombre: 'Comida libre' };
        } else {
          day.dieta = dieta.nombre ? { nombre: dieta.nombre, documentId: dieta.documentId } : {}; // Asigna la dieta
        }
      });
      this.selectedDays = [];
    }
    // Limpia la selección después de asignar la dieta
    console.log('Dietas asignadas. Semanas actualizadas:', this.semanas);
    this.guardarCambios('rutinasPorDia')
  }

}
